import React from "react";
import { NavLink } from "react-router-dom";

export default function NavItem({ url, children }) {
  return (
    <li>
      <NavLink
        exact
        to={url}
        className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
        activeClassName="bg-gray-900 text-white px-3 py-2 rounded-md text-sm font-medium"
      >
        {children}
      </NavLink>
    </li>
  );
}
